/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./alarmTable.vue?vue&type=template&id=87f3249e"
import script from "./alarmTable.vue?vue&type=script&lang=js"
export * from "./alarmTable.vue?vue&type=script&lang=js"
import style0 from "./alarmTable.vue?vue&type=style&index=0&id=87f3249e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports